const env = import.meta.env || {}

const getEnvValue = (keys, fallback = '') => {
  for (const key of keys) {
    const value = env[key]
    if (typeof value === 'string' && value.length > 0) {
      return value
    }
  }
  return fallback
}

const parseList = (value) =>
  value
    .split(',')
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean)

const parseBoolean = (value, fallback = false) => {
  if (typeof value !== 'string') {
    return fallback
  }

  const normalized = value.trim().toLowerCase()
  if (['true', '1', 'yes', 'y', 'on'].includes(normalized)) {
    return true
  }
  if (['false', '0', 'no', 'n', 'off'].includes(normalized)) {
    return false
  }
  return fallback
}

const DEFAULT_ADMIN_EMAILS = ['dballiet+admin@gmail.com']

export const ADMIN_EMAIL_ALLOWLIST = (() => {
  const raw = getEnvValue(
    ['VITE_ADMIN_EMAIL_ALLOWLIST', 'ADMIN_EMAIL_ALLOWLIST'],
    DEFAULT_ADMIN_EMAILS.join(',')
  )

  const parsed = parseList(raw)
  return parsed.length > 0 ? parsed : DEFAULT_ADMIN_EMAILS
})()

export const AI_LAB_ENABLED = (() => {
  const raw = getEnvValue(['VITE_AI_LAB_ENABLED', 'AI_LAB_ENABLED'], 'false')
  return parseBoolean(raw, false)
})()

// Google sign-in is hidden until GOOGLE_CLIENT_ID/SECRET are set on the Worker.
export const GOOGLE_AUTH_ENABLED = (() => {
  const raw = getEnvValue(['VITE_GOOGLE_AUTH_ENABLED', 'GOOGLE_AUTH_ENABLED'], 'false')
  return parseBoolean(raw, false)
})()

export const DEFAULT_AI_LAB_LEVEL = 'Squirt B1'

export const DEFAULT_AI_LAB_MODELS = [
  'x-ai/grok-code-fast-1',
  'x-ai/grok-4-fast',
  'openai/gpt-5-mini',
  'anthropic/claude-haiku-4.5',
  'google/gemini-2.5-flash',
  'deepseek/deepseek-chat-v3-0324',
]

